<template>
    <div>
        <select :id="id" class="form-control"></select>
    </div>
</template>

<script>
module.exports = {
    name: "select-two-supplier",
    props: {
        endpoint: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true,
        },
        dropdownParent: {
            type: String,
            default: "body"
        },
        value: {
            type: Object,
        },
        initialValue: {
            type: Number,
            required: false
        },
        initialDisplay: {
            type: String,
            required: false
        },
        type: {
            type: String,
            default: "all"
        }
    },
    data(){
        return {
            items: [],
            loading: true,
            selectedItem: this.value
        }
    },
    watch: {
        value: function(val){
            $("#"+this.id).html("<option value='"+val.id+"' selected>"+val.text+"</option>")
        }
    },
    mounted(){
        this.init();
    },
    methods:{
        init: function(){
            var that = this;
            
            if(this.initialValue !== undefined){
                $("#"+this.id).html("<option value='"+this.initialValue+"' selected>"+this.initialDisplay+"</option>")
            }

            $("#"+this.id).select2({
                language: "fr",
                ajax: {
                    url: that.endpoint,
                    dataType: 'json',
                    data: function (params) {
                        return {
                            search: params.term,
                            type: that.type,
                            page: params.page || 1
                        }
                    },
                    processResults: function (data) {
                        data.results.forEach(function(result) {
                            result.id = result.type+"-"+result.id;
                        });
                        return data;
                    }
                },
                placeholder: "",
                allowClear: true,
                dropdownParent: $(that.dropdownParent),
                searchInputPlaceholder: "Rechercher...",
                templateResult: that.renderMethod
            }).on("select2:select", function(data){
                var dat = data.params.data;
                that.$emit("selected", dat);
                that.$emit('input', dat);
            }).on("select2:clear", function(data){
                that.$emit("clear");
                that.$emit('input', {id: null, text: ""});
            });

        },
        renderMethod: function(state){
            if (!state.id) {
                return "Chargement des résultats...";
            }
            var $state = $('<span><span>'+(state.text != '' ? state.text : "<em>Sans nom</em>")+'</span></span>');
            return $state;
        }
    }
}
</script>